import { QueryClient } from '@tanstack/react-query';

/**
 * The app-wide TanStack Query client.
 *
 * Defaults tuned for a patchy-4G audience: cache stays fresh for a minute (home data rarely
 * changes within a visit), retry a couple of times for transient network blips, and don't
 * refetch on every window focus (saves bytes on a metered connection). Mounted once in
 * App.jsx via <QueryClientProvider>.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});
